import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./AuthProvider";
import { RedirectIfSignedIn, RequireAdmin, RequireAuth } from "./RouteGuards";
import AppShell from "./AppShell";
import { SearchProvider } from "./SearchProvider";
import { LogoProvider } from "./LogoProvider";
import LoginPage from "../pages/LoginPage";
import SearchPage from "../pages/SearchPage";
import ResultsPage from "../pages/ResultsPage";
import HistoryPage from "../pages/HistoryPage";
import HistoryDetailPage from "../pages/HistoryDetailPage";
import UserManagementPage from "../pages/UserManagementPage";
import LogoGeneratorPage from "../pages/LogoGeneratorPage";
import LogoEditPage from "../pages/LogoEditPage";
import NdaGeneratorPage from "../pages/NdaGeneratorPage";
import PotentialLicensingPage from "../pages/PotentialLicensingPage";
import IndianTrademarkDataPage from "../pages/IndianTrademarkDataPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SearchProvider>
          <LogoProvider>
            <Routes>
              <Route
                path="/login"
                element={
                  <RedirectIfSignedIn>
                    <LoginPage />
                  </RedirectIfSignedIn>
                }
              />

              {/* Everything below requires a session. AppShell renders the
                  sidebar once and an <Outlet /> for whichever page matched. */}
              <Route
                element={
                  <RequireAuth>
                    <AppShell />
                  </RequireAuth>
                }
              >
                <Route path="/" element={<SearchPage />} />
                <Route path="/results" element={<ResultsPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/history/:id" element={<HistoryDetailPage />} />
                <Route path="/logo-generator" element={<LogoGeneratorPage />} />
                <Route path="/logo-editor" element={<LogoEditPage />} />
                <Route path="/nda" element={<NdaGeneratorPage />} />
                <Route
                  path="/potential-licensing"
                  element={<PotentialLicensingPage />}
                />
                <Route
                  path="/indian-trademarks"
                  element={<IndianTrademarkDataPage />}
                />
                <Route
                  path="/users"
                  element={
                    <RequireAdmin>
                      <UserManagementPage />
                    </RequireAdmin>
                  }
                />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </LogoProvider>
        </SearchProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
